import React from "react";
import "./style.scss";
import { IHeading } from "./Heading";

const Heading: React.FunctionComponent<IHeading.IProps> = (
    props
): JSX.Element => {
    const { text } = props;

    return (
        <div className="title">
            <span className="title__back">{text}</span>
            <span className="title__front">{text}</span>
        </div>
    );
};

export { Heading };
